import { getBrand } from "@faire/help-center-utils/serialized-data/getBrand";

import { SelfServeContext } from "../../../types";

export const brandActivePeteEventDataFn = (_context?: SelfServeContext) => {
  return Promise.resolve(getBrand()?.active ? "ACTIVE" : "INACTIVE");
};
